import { autoLoginPartialRoutesGuard } from "angular-auth-oidc-client";

import { NgModule } from "@angular/core";
import { RouterModule, Routes, TitleStrategy } from "@angular/router";

import { AboutPage } from "../pages/about/about";
import { DisclaimerPage } from "../pages/disclaimer/disclaimer";
import { ErrorPage } from "../pages/error/error";
import { ForbiddenPage } from "../pages/forbidden/forbidden";
import { NotfoundPage } from "../pages/notfound/notfound";
import { ReuseTitleResolverStrategy } from "../resolvers/title-strategy";
// TODO Put components in this module
import { translateTitleResolver } from "../resolvers/translate-title-resolver";
import { ENV } from "./app.runtime";
import { AuthGuard } from "./auth/guard";
import { routes as dashboard } from "./dashboard/dashboard-routing.module";

const OIDC_GUARD = (ENV.AUTH_ENABLED ?? true) ? autoLoginPartialRoutesGuard : () => true;

const domains: Routes = [
  {
    path: "domains",
    loadChildren: () => import("./domains/domains.module").then((m) => m.DomainsModule),
    // OIDC_GUARD must sit alongside AuthGuard, not on the child routes: guards on one
    // route run concurrently, across route levels they run sequentially. AuthGuard blocks
    // on userLoaded, which only emits after login, so a child-level OIDC guard would never
    // be reached on a direct visit.
    canActivate: [OIDC_GUARD, AuthGuard],
    title: () => translateTitleResolver("SURFdomeinen"),
  },
];

const news: Routes = [
  {
    path: "news",
    loadChildren: () => import("./news/news.module").then((m) => m.NewsModule),
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "news",
  },
];

const general: Routes = [
  {
    path: "over-surf",
    component: AboutPage,
    title: () => translateTitleResolver("Footer.AboutSurf"),
  },
  { path: "disclaimer", component: DisclaimerPage, title: () => translateTitleResolver("Footer.Disclaimer") },
  { path: "error", component: ErrorPage, title: () => translateTitleResolver("Global.Error") },
  { path: "notfound", component: NotfoundPage, title: () => translateTitleResolver("Global.NotFound") },
  { path: "forbidden", component: ForbiddenPage, title: () => translateTitleResolver("Global.NoAccess") },
  { path: "**", redirectTo: "notfound" },
];

const allowed = ENV.ENABLED_ROUTES.split(",");
let routes: Routes = [];
if (allowed.includes("dashboard")) routes = routes.concat(dashboard);
if (allowed.includes("domains")) routes = routes.concat(domains);
if (allowed.includes("news")) routes = routes.concat(news);
routes = routes.concat(general);

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      bindToComponentInputs: true,
    }),
  ],
  providers: [{ provide: TitleStrategy, useClass: ReuseTitleResolverStrategy }],
  exports: [RouterModule],
})
export class AppRoutingModule {}
